import React from "react";
import { InfoModal, INFO_MODAL_NEW_TRANSFER_URL } from "./InfoModal";

interface FreedomLoanNumberModalProps {
	open: boolean;
	onClose: () => void;
	onVisitNewTransfer?: () => void;
	// Deprecated compatibility prop.
	onContactSupport?: () => void;
}

export const FreedomLoanNumberModal: React.FC<FreedomLoanNumberModalProps> = ({
	open,
	onClose,
	onVisitNewTransfer,
	onContactSupport,
}) => {
	const handleVisitNewTransfer =
		onVisitNewTransfer ??
		onContactSupport ??
		(() => {
			window.open(INFO_MODAL_NEW_TRANSFER_URL, "_blank", "noopener,noreferrer");
		});

	return (
		<InfoModal
			open={open}
			onClose={onClose}
			title="Freedom Loan Number"
			secondaryAction={{
				label: "Visit New Transfer",
				variant: "outlined",
				onClick: handleVisitNewTransfer,
			}}
			primaryAction={{
				label: "Ok",
				variant: "filled",
				onClick: onClose,
			}}
		/>
	);
};
